import React from "react";
import "../style/fixturesTable.scss";

const FixturesTable = (props) => {
  if (props.data && props.data.length > 0) {
    const heading = props.data[0];
    const headers = props.data[1];
    const data = props.data.slice(2, props.data.length);
    console.log(heading, headers, data);
    return (
      <table>
        <thead>
          <tr>
            {headers.map((header, i) => (
              <th key={i}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              {row.map((item, x) => (
                <td key={x}>{item}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
  return "";
};

export default FixturesTable;
